import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

export const useGTMPage = () => {
  const page = useEngineStore((state) => state.page);

  useEffect(() => {
    TagManager.dataLayer({ dataLayer: { event: GTMEvent.VirtualPageView, page } });
  }, [page]);
};
